import { useState } from 'react';
import { generateApprovalDocId } from '@/utils/approval';

/**
 * 전자결재 작성 폼의 docId 초기화.
 * - 신규 작성: 폼 진입 시 클라이언트에서 1회 생성하고 이후 변경 없음
 * - 수정 진입: 기존 docId(URL `doc` 파라미터 등)를 그대로 사용
 *
 * 호출부에서 router.isReady 확인 후 마운트되도록 보장할 것.
 * (라우터가 준비되기 전에 마운트되면 신규로 잘못 생성될 수 있음)
 */
const useApprovalDocId = (existingDocId?: string | null): string => {
  const [docId] = useState(() => existingDocId || generateApprovalDocId());
  return docId;
};

export default useApprovalDocId;
